import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const preferredLanguageSlice = createSlice({
  name: "preferredLanguage",
  initialState: "",
  reducers: {
    setPreferredLanguage: (_state: any, action: PayloadAction<any>) => action.payload,
  },
});

export const { setPreferredLanguage } = preferredLanguageSlice.actions;
export default preferredLanguageSlice.reducer;
